export const mobileHeader = 996;
export const popout = 997;
export const navigation = 999;
export const drawer = 999;
export const snackBar = 10000;
export const startIndex = 100001;
export const videoThumbnail = 300;
export const dashboardScroll = 450;
export const videoAnalytics = 500;
